import script from "./PartnerSlotsDashboard.vue?vue&type=script&setup=true&lang=ts"
export * from "./PartnerSlotsDashboard.vue?vue&type=script&setup=true&lang=ts"

import "./PartnerSlotsDashboard.vue?vue&type=style&index=0&id=1d47c194&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d47c194"]])

export default __exports__